import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiStripepaymentgatewayGetCompletePaymentsQueryResponse,
  GetApiStripepaymentgatewayGetCompletePaymentsQueryParams,
  GetApiStripepaymentgatewayGetCompletePayments401,
  GetApiStripepaymentgatewayGetCompletePayments403,
} from "../../../types/GetApiStripepaymentgatewayGetCompletePayments";

export function getGetApiStripepaymentgatewayGetCompletePaymentsUrl() {
  return `/api/StripePaymentGateway/get-complete-payments` as const;
}

/**
 * {@link /api/StripePaymentGateway/get-complete-payments}
 */
export async function getApiStripepaymentgatewayGetCompletePayments(
  params?: GetApiStripepaymentgatewayGetCompletePaymentsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiStripepaymentgatewayGetCompletePaymentsQueryResponse,
    ResponseErrorConfig<
      | GetApiStripepaymentgatewayGetCompletePayments401
      | GetApiStripepaymentgatewayGetCompletePayments403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiStripepaymentgatewayGetCompletePaymentsUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
